module.exports = __webpack_public_path__ + "static/media/inspira.1d72e963.webp";